import React from "react";
import {Form, Button, Alert} from "react-bootstrap";
import {Navigate} from "react-router-dom"
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {AppContext} from "../../AppContext";
import axios from "axios";
import DbUser from "../../queries/DbUser";

const {Component} = require("react");

class CategoryAdd extends Component {

    static contextType = AppContext;

    state = {
        categoryName: '',
        validatorMessage: '',
        exit: false,
        redirect: ''
    }

    componentDidMount() {
        DbUser.getLoggedUser(this.context)
    }

    handleSubmit = (e) => {
        if (this.state.categoryName.length < 3) {
            this.setState({
                ...this.state, validatorMessage: 'Kategoria musi mieć minimum 3 znaki'
            })
        } else {
            this.submitToAPI(this.state.categoryName)
        }
    }

    submitToAPI = (categoryName) => {
        axios.post(`${this.context.hostname}/api/category/insert`, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                },
                "name": categoryName,
            },
            {withCredentials: true}
        ).then(res => {
            if (res.status === 200) {
                console.log(res)
                this.setState({...this.state, categoryName: '', validatorMessage: '', exit: true,})
            }
        })
            .catch((error) => {
                console.log({error})
                let validatorMessage = 'Nieznany błąd.';
                if (error.response.status === 409) {
                    validatorMessage = 'Podana kategoria już istnieje!'
                }
                this.setState({...this.state, validatorMessage: validatorMessage})
            });
    }

    handleChange = (e) => {
        const name = e.target.value;
        this.setState(
            {...this.state, categoryName: name}
        )
    }

    handleBackOnClick = () => {
        this.setState({...this.state, redirect: '/categoryList'})
    }

    render() {
        if (this.state.exit === true) {
            return (<Navigate to="/categoryList"/>
            )
        }

        return (
            <div className="fragment">
                {this.context.redirectToLoginPage ? <Navigate to="/login"/> : ''}
                {this.state.redirect != '' ? <Navigate to={this.state.redirect}/> : ''}

                <h3>
                    <Button variant="light" onClick={this.handleBackOnClick}>
                        <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-arrow-return-left"
                             fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                  d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5z"/>
                        </svg>
                    </Button>
                    &nbsp;Dodawanie kategorii
                </h3>
                <Row>
                    <Col sm={5}>
                        <Form>
                            <Form.Group>
                                <Form.Label>Nazwa kategorii</Form.Label>
                                <Form.Control
                                    style={{marginTop: 10, marginBottom: 10}}
                                    type="text" name="categoryName"
                                    value={this.state.categoryName}
                                    placeholder="Wpisz kategorie..."
                                    onChange={this.handleChange}
                                />
                                {this.state.validatorMessage != '' ?
                                    <Alert variant='danger'>
                                        {this.state.validatorMessage}
                                    </Alert> : false
                                }
                            </Form.Group>
                            <Button
                                variant="outline-dark"
                                onClick={this.handleSubmit}
                                size="sm"
                                style={{marginRight: "5px"}}>
                                Dodaj
                            </Button>
                            <Button
                                size="sm"
                                variant="outline-dark"
                                onClick={() => this.setState({...this.state, redirect: '/categoryList'})}>
                                Anuluj
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default CategoryAdd;
